particle-treaty-status-viewer{display:flex}particle-treaty-status-viewer .content.pos-relative{min-height:311px}
/*# sourceMappingURL=treaty-status-viewer.component-4NAWDR3X.css.map */
